import { createContext, useContext, type MutableRefObject } from 'react';

import type { DateLinkingConfig } from './config';

type LeaseDetailsDateLinkingContextValue = {
  config?: DateLinkingConfig;
  endDateManuallyEdited: MutableRefObject<boolean>;
};

export const LeaseDetailsDateLinkingContext =
  createContext<LeaseDetailsDateLinkingContextValue | null>(null);

export const useLeaseDetailsDateLinking = (): LeaseDetailsDateLinkingContextValue | null => {
  return useContext(LeaseDetailsDateLinkingContext);
};
